module.exports = __webpack_public_path__ + "img/layout_01_default.f199a8f8.svg";